import { types } from 'mobx-state-tree'
import { my_experiences__get } from '../api/experiences'
import group_experiences from '../api/group_experiences'

const MyExperiencesStore = types.model({
  loaded: types.optional(types.boolean, false),
  data: types.optional(types.frozen, [])
}).views(
  /**
   * @param {Object} self
   * @returns {Object}
   */
  self => ({
    get grouped_experiences () {
      if (!self.loaded) {
        return false
      }
      let objects = self.data
      return group_experiences({objects})
    }
  })
).actions(
  /**
   * @param {Object} self
   * @returns {Object}
   */
  self => ({
    get (token) {
      self.loaded = false
      my_experiences__get(token).then(
        self.fetch
      )
    },
    fetch (data) {
      self.data = data
      self.loaded = true
    },
    clean () {
      self.data = false
      self.loaded = false
    }
  })
)

export default MyExperiencesStore



// WEBPACK FOOTER //
// ./src/stores/MyExperiencesStore.js